<template>
  <div class="marketplace-table--footer p-md" :class="cancelled ? 'cancelled' : ''">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MarketplaceTableFooter',
  props: {
    cancelled: {type: Boolean, default: false}
  }
};
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace-table--footer {
  display: flex;
  align-items: center;
  column-gap: 0.8rem;
  border-top: 1px solid $color-gray-400;
  border-radius: 0 0 1.2rem 1.2rem;

  &.cancelled {
    background-color: #fffbeb;
  }
}
</style>
